export class CnpjUtils {
  private static readonly CNPJ_MASK_SEPARATORS_REGEX = /[.\-\/]/g;
  private static readonly CNPJ_ALPHANUMERIC_REGEX = /^[A-Z0-9]{14}$/;

  static sanitize(cnpj: string | null | undefined): string | null {
    if (!cnpj) return null;

    return cnpj
      .trim()
      .toUpperCase()
      .replace(this.CNPJ_MASK_SEPARATORS_REGEX, '');
  }

  static isCnpj(value: string | null | undefined): boolean {
    if (!value) return false;
    const cleaned = value.replace(this.CNPJ_MASK_SEPARATORS_REGEX, '').replace(/\s/g, '');
    return cleaned.length > 11 || /[a-zA-Z]/.test(cleaned);
  }

  static formatWithMask(cnpj: string | null | undefined): string | null {
    const sanitized = this.sanitize(cnpj);
    return sanitized.replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})/, '$1.$2.$3/$4-$5');
  }

  static formatWithMaskOrDefault(cnpj: string | null | undefined): string | null {
    const sanitized = this.sanitize(cnpj);
    if (!sanitized || sanitized.length < 14) return sanitized;
    return this.formatWithMask(sanitized);
  }

  static isValidWithCheckDigits(cnpj: string | null | undefined): boolean {
    const sanitized = this.sanitize(cnpj);
    if (!sanitized || !this.CNPJ_ALPHANUMERIC_REGEX.test(sanitized)) {
      return false;
    }

    const base = sanitized.substr(0, 12);
    const comPrimeiroDigito = this.calcDigitosPosicoes(base, 5);
    const completo = this.calcDigitosPosicoes(comPrimeiroDigito, 6);
    return completo === sanitized;
  }

  private static calcDigitosPosicoes(digitos: string, posicoes = 10, somaDigitos = 0): string {
    let auxPos = posicoes;
    let auxSum = somaDigitos;

    for (const ch of digitos) {
      auxSum += this.charToValue(ch) * auxPos;
      auxPos--;
      if (auxPos < 2) {
        auxPos = 9;
      }
    }

    auxSum = auxSum % 11;
    auxSum = auxSum < 2 ? 0 : 11 - auxSum;

    return digitos + auxSum;
  }

  private static charToValue(char: string): number {
    return char.charCodeAt(0) - 48;
  }
}
